"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePassword = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const AppContext_1 = require("../../utils/AppContext");
const utils_1 = require("../../utils/utils");
const ZAlert_1 = require("../../components/ZAlert/ZAlert");
const Header = styled_components_1.default.div `
   background: linear-gradient(to right, #eaeaea, #d2d2d2, #eaeaea);
   border-radius: 5px 5px 0 0;
   padding: 11px;
   width: calc(100% - 22px);
   text-align: center;
   height: 99px;
`;
const HeaderImage = styled_components_1.default.img.attrs(props => ({
    alt: "Tenant Logo",
    src: props.src
})) `
   width: 100% - 2px;
   height: 58px;
   margin-bottom: 11px;
   vertical-align: middle;
`;
const HeaderTitle = styled_components_1.default.div `
   font-size: 22px;
   color: #333;
   line-height: 30px;
   padding-bottom: 3px;
   font-family: ${props => props.theme["font-family"]};
`;
const PasswordContainer = styled_components_1.default.div `
   width: 100%;
   min-height: 130px;
   height: auto;
   background-color: #fff;

   input {
      border: solid 1px rgb(241, 241, 241) !important;
      border-radius: 3px !important;
   }
`;
const EmailMessage = styled_components_1.default.div `
   margin-top: 20px;
   margin-bottom: 20px;
   text-align: center;
   font-size: 13px;
   color: grey;
`;
const EmailTextBox = styled_components_1.default.input.attrs(props => ({
    placeholder: "Email",
    type: "email"
})) `
   width: 85%;
   height: 40px;
   padding-left: 5px;
   position: relative;
   margin-bottom: 20px;
`;
const Requirements = () => (React.createElement("ul", null,
    React.createElement("li", { className: "match" }, "Password must match"),
    React.createElement("li", { className: "length" }, "Password must be at least 8 characters long"),
    React.createElement("li", { className: "lower" }, "Password must contain a lower case letter (a-z)"),
    React.createElement("li", { className: "upper" }, "Password must contain an upper case letter (A-Z)"),
    React.createElement("li", { className: "number" }, "Password must contain a number (0-9)"),
    React.createElement("li", { className: "special" }, "Password must contain at least one special character (!@#$%^&*)")));
const PasswordTextBox = styled_components_1.default.input.attrs(props => ({
    placeholder: "Password",
    type: "password"
})) `
   width: 85%;
   height: 40px;
   padding-left: 5px;
   margin-top: 3px;
   margin-bottom: 7.5px;
`;
const ConfirmPasswordTextBox = styled_components_1.default.input.attrs(props => ({
    placeholder: "Confirm Password",
    type: "password"
})) `
   width: 85%;
   height: 40px;
   padding-left: 5px;
   margin-bottom: 15px;
`;
const Arrow = (props) => (React.createElement("svg", { focusable: "false", className: "submit-arrow", width: "8px", height: "12px", style: {
        transformBox: "fill-box",
        transformOrigin: "center",
        transform: `rotate(${props.flip ? "180deg" : 0})`
    } },
    React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("g", { transform: "translate(-148.000000, -32.000000)", fill: "#FFFFFF" },
            React.createElement("polygon", { points: "148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38" })))));
const SubmitText = styled_components_1.default.span `
   color: #fff;
   letter-spacing: 1px;
   text-transform: uppercase;
   height: 42px;
   line-height: 42px;
   cursor: pointer;
   font: inherit;
   transition: 0.2s ease-in-out;
   padding-left: 2px;
   padding-right: 2px;

   .submit-arrow {
      position: relative;
      top: 1px;
      padding-right: 1px;
   }
`;
const SubmitButton = styled_components_1.default.button `
   cursor: pointer;
   background-color: ${props => props.theme["app-link-color"]};
   display: block;
   border: 0;
   position: relative;
   left: -1px;
   width: calc(100% + 2px);
   color: #fff;
   font-family: ${props => props.theme["font-family"]};
   border-radius: 0 0 5px 5px;
   padding: 14px;
   height: 70px;

   span {
      font-size: 1em;
      transition: all 250ms ease;
   }

   :hover {
      background-color: ${props => props.theme["hover-color"]};
      span {
         font-size: 1.05em;
      }
   }

   :active {
      background-color: ${props => props.theme["active-color"]};
   }
`;
const isPasswordValid = (password, confirmPassword) => {
    const errors = [];
    if ((password.length === 0 && confirmPassword.length === 0) ||
        password !== confirmPassword) {
        errors.push("match");
    }
    if (password.length < 8) {
        errors.push("length");
    }
    const hasLower = password.length === 0
        ? false
        : password
            .split("")
            .map(c => (c.match(/[a-z]/) === null ? false : true))
            .includes(true);
    if (!hasLower) {
        errors.push("lower");
    }
    const hasUpper = password.length === 0
        ? false
        : password
            .split("")
            .map(c => (c.match(/[A-Z]/) === null ? false : true))
            .includes(true);
    if (!hasUpper) {
        errors.push("upper");
    }
    const hasNumber = password.length === 0
        ? false
        : password
            .split("")
            .map(c => isNaN(parseInt(c)))
            .includes(false);
    if (!hasNumber) {
        errors.push("number");
    }
    const hasSpecial = password.contains("!") ||
        password.contains("@") ||
        password.contains("#") ||
        password.contains("$") ||
        password.contains("%") ||
        password.contains("^") ||
        password.contains("&") ||
        password.contains("*");
    if (!hasSpecial) {
        errors.push("special");
    }
    return errors.length === 0 ? true : errors;
};
const getToken = () => {
    const queryStrings = utils_1.getQueryStrings();
    return "token" in queryStrings ? queryStrings["token"] : undefined;
};
const hasError = (valid, error) => {
    if (valid === true) {
        return false;
    }
    else if (valid.includes(error)) {
        return true;
    }
    return false;
};
exports.ChangePassword = (props) => {
    const theme = React.useContext(styled_components_1.ThemeContext);
    const { apiClient, config } = React.useContext(AppContext_1.AppContext);
    const { issueAlert } = ZAlert_1.useAlerts();
    const [email, setEmail] = React.useState("");
    const [emailInput, setEmailInput] = React.useState(false);
    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");
    const passwordValid = React.useMemo(() => isPasswordValid(password, confirmPassword), [password, confirmPassword]);
    const token = getToken();
    const tokenIsValid = token !== undefined;
    const red = theme["red"];
    const green = "green";
    const RequirementsWrapper = styled_components_1.default.div `
      font-size: 12px;
      line-height: 12px;

      ul {
         padding-left: 25px;
      }

      .match {
         color: ${hasError(passwordValid, "match") ? red : green};
      }
      .length {
         color: ${hasError(passwordValid, "length") ? red : green};
      }
      .lower {
         color: ${hasError(passwordValid, "lower") ? red : green};
      }
      .upper {
         color: ${hasError(passwordValid, "upper") ? red : green};
      }
      .number {
         color: ${hasError(passwordValid, "number") ? red : green};
      }
      .special {
         color: ${hasError(passwordValid, "special") ? red : green};
      }
   `;
    const onSendEmail = () => {
        if (email.trim() !== "" && emailInput) {
            let brand;
            const themeName = theme["name"];
            if (themeName === "Service Pro 10") {
                brand = "servicepro";
            }
            else if (themeName === "Admin Console") {
                brand = "admin";
            }
            else if (themeName.contains("Service Pro Portal")) {
                brand = "portal";
            }
            else if (themeName === "Trimble Pulse") {
                brand = "trimblepulse";
            }
            else {
                brand = "servicepro";
            }
            apiClient
                .request({
                method: "POST",
                url: `${config.serviceProApiUrl}/api/Password/RequestReset`,
                data: {
                    EmailAddress: email,
                    ChangePasswordUrl: document.location.origin,
                    Brand: brand
                }
            })
                .then(() => {
                issueAlert({
                    type: "success",
                    header: "EmailSent",
                    message: "PasswordResetEmailSuccess",
                    autoHideDuration: 10000
                });
            })
                .catch(() => {
                issueAlert({
                    type: "error",
                    header: "Error",
                    message: "RequestErrorMessage"
                });
            });
        }
        else {
            setEmailInput(true);
        }
    };
    const onChangePassword = () => {
        if (passwordValid === true && tokenIsValid) {
            apiClient
                .request({
                method: "POST",
                url: `${config.serviceProApiUrl}/api/Password/Reset`,
                data: {
                    Token: token,
                    NewPassword: password
                }
            })
                .then(resp => {
                issueAlert({
                    type: "success",
                    header: "Password Updated",
                    message: "Password Successfully Updated. Returning to Login...",
                    localize: false
                });
                setTimeout(() => {
                    document.location.assign(`${document.location.origin}/Login`);
                }, 5000);
            })
                .catch(err => {
                issueAlert({
                    type: "error",
                    header: "Update Failed",
                    message: "Password Failed to Update",
                    localize: false
                });
            });
        }
    };
    React.useEffect(() => {
        const handler = (e) => {
            if (e.key === "Enter") {
                if (passwordValid) {
                    onChangePassword();
                }
                else if (email.trim() !== "") {
                    onSendEmail();
                }
            }
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(HeaderImage, { src: theme["app-logo-color-url"] }),
            React.createElement(HeaderTitle, null, tokenIsValid ? "Change Password" : "Reset Password")),
        React.createElement(PasswordContainer, null, tokenIsValid ? (React.createElement(React.Fragment, null,
            React.createElement(RequirementsWrapper, null,
                React.createElement(Requirements, null)),
            React.createElement(PasswordTextBox, { value: password, onChange: e => setPassword(e.target.value) }),
            React.createElement(ConfirmPasswordTextBox, { value: confirmPassword, onChange: e => setConfirmPassword(e.target.value) }))) : (React.createElement(React.Fragment, null,
            React.createElement(EmailMessage, null, "Please enter your email address. We will send you an email to reset your password."),
            email.trim() === "" && emailInput && (React.createElement(EmailMessage, { style: {
                    color: red
                } }, "Please enter your email address.")),
            React.createElement(EmailTextBox, { value: email, onChange: e => setEmail(e.target.value), onInput: e => setEmailInput(true) })))),
        React.createElement(SubmitButton, { onClick: e => (tokenIsValid ? onChangePassword() : onSendEmail()) },
            React.createElement(React.Fragment, null,
                React.createElement(SubmitText, null, tokenIsValid ? "Submit" : "Send Email"),
                React.createElement(Arrow, null)))));
};
//# sourceMappingURL=ChangePassword.js.map